module.exports = __webpack_public_path__ + "img/stamp-insect.f1007ea2.png";